<template lang="pug">
.grid
  aiq-row.categories-row(:gutter="24")
    aiq-col(:span="show_agent_frt ? 12 : 16")
      performance-category(:category="categories.communication" v-bind="$attrs" :selected-metric="selectedMetric")
    aiq-col(:span="show_agent_frt ? 12 : 8")
      performance-category(:category="categories.responsiveness" v-bind="$attrs" :selected-metric="selectedMetric")
  aiq-row.categories-row
    aiq-col(:span="24")
      performance-category(:category="categories.relationship" v-bind="$attrs" :selected-metric="selectedMetric")
</template>


<script>
import PerformanceCategory from './PerformanceCategory.vue';
import { mapState } from 'vuex';

export default {
  name: 'PerformanceGrid',
  components: {
    PerformanceCategory,
  },
  computed: {
    ...mapState({
      show_agent_frt: state => state.featureFlags.FEATURE_FLAGS.SHOW_AGENT_FRT,
    }),
  },
  props: {
    categories: {
      type: Object,
      required: true,
    },
    selectedMetric: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.categories-row {
  margin-bottom: 20px;
}
</style>
